module.exports = __webpack_public_path__ + "img/LogoColorful.d41f42bc.png";